import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthLoadingBackdrop } from '@/components/layout/AuthLoadingBackdrop';
import { useAuth } from '@/lib/firebase/auth';
import { useAuthorization } from '@/lib/firebase/authorization';

const AuthRoute = ({ permissions = [], appRoles = [], clientId = null }) => {
  const { user, loading: authLoading } = useAuth();
  const { isAuthorized, hasAppRole, loading: permissionsLoading } = useAuthorization(permissions, appRoles, clientId);

  // If auth or permissions are loading, show loading indicator
  if (authLoading || permissionsLoading) {
    return <AuthLoadingBackdrop />;
  }

  // If user is logged out, redirect to the login page
  if (!user) {
    return <Navigate to="/login" />;
  }

  // Check if email is verified, if not redirect to the verification page
  if (!user.emailVerified) {
    return <Navigate to="/verify-email" />;
  }

  // If no permissions or appRoles are specified, allow the user to proceed if logged in
  if (permissions.length === 0 && appRoles.length === 0) {
    return <Outlet />;
  }

  // If user is logged in but does not have the required permissions or role, render nothing
  if (!isAuthorized) {
    console.warn("Not authorized.");
    return <Navigate to="/" />;  // Redirect to home or render a 404 page
  }

  // If the user is authorized, render the route (Outlet)
  return <Outlet />;
};

export { AuthRoute };
